import IngestGroup from '../../common/domain/IngestGroup';
import {
  BQUploadState,
  IngestState,
  MappingState,
  ProgressState,
  VerificationState,
} from './ingestSlice';
import { AlertsState } from '../alerts/alertsSlice';
import { Action, SelectionAction } from '../';
import { IngestFileType } from '../../common/domain/IngestFileType';
import FileFormatLink from '../../common/domain/FileFormatLink';
import fepLinearSchema from '../../pages/IngestPage/schema/FepLinear';

export const loadGroups = (
  state: IngestState,
  action: SelectionAction<IngestGroup>,
) => {
  const { loading, items } = action.payload;
  state.groupSelector.isLoading = loading;
  state.groupSelector.items =
    items?.map((group) => {
      return { id: group.id, name: group.name, item: group };
    }) ?? [];
  return state;
};

export const selectGroup = (
  state: IngestState,
  action: SelectionAction<IngestGroup>,
) => {
  const { selection } = action.payload;
  if (selection == null) return state;
  state.groupSelector.selectedItem = {
    id: selection.id,
    name: selection.name,
    item: selection,
  };
  return state;
};

export const loadFileTypes = (
  state: IngestState,
  action: SelectionAction<IngestFileType>,
) => {
  state.fileTypeSelector.isLoading = action.payload.loading;
  state.fileTypeSelector.items =
    action.payload.items?.map((ft) => {
      return {
        id: ft.internalId,
        name: ft.name,
        item: ft,
      };
    }) ?? [];
};

export const selectFileType = (
  state: IngestState,
  action: SelectionAction<IngestFileType>,
) => {
  const { selection } = action.payload;
  if (selection == null) return state;
  state.fileTypeSelector.selectedItem = {
    id: selection.internalId,
    name: selection.name,
    item: selection,
  };
  return state;
};

export const loadFileFormats = (
  state: IngestState,
  action: SelectionAction<FileFormatLink>,
) => {
  state.fileFormatSelector.isLoading = action.payload.loading;
  state.fileFormatSelector.items =
    action.payload.items?.map((link) => {
      return { id: link.id, name: link.id, item: link };
    }) ?? [];
  return state;
};

export const selectUploadFile = (
  state: IngestState,
  action: SelectionAction<File>,
) => {
  state.fileToUpload = action.payload.selection;
  return state;
};

export const updateProgress = (
  state: IngestState,
  action: Action<ProgressState>,
) => {
  state.progress = action.payload;
  return state;
};

export const initializeMapping = (
  state: IngestState,
  action: Action<MappingState>,
) => {
  state.progress = undefined;
  state.verification = undefined;
  state.bqUpload = undefined;
  state.mapping = action.payload;
  return state;
};

export const initializeVerification = (
  state: IngestState,
  action: Action<VerificationState>,
) => {
  state.progress = undefined;
  state.mapping = undefined;
  state.bqUpload = undefined;
  state.verification = action.payload;
  return state;
};

export const initializeBQUpload = (
  state: IngestState,
  action: Action<BQUploadState>,
) => {
  state.progress = undefined;
  state.mapping = undefined;
  state.bqUpload = action.payload;
  state.verification = undefined;
  return state;
};

export const resetUpload = (state: IngestState) => {
  state.progress = undefined;
  state.mapping = undefined;
  state.bqUpload = undefined;
  state.verification = undefined;
  state.fileToUpload = undefined;
  state.fileTypeSelector.selectedItem = undefined;
  state.groupSelector.selectedItem = undefined;
  state.fileFormatSelector.selectedItem = undefined;
  return state;
};
